'use client';

import { PrivyProvider } from '@privy-io/react-auth';
import { WithChildren } from '@vertex-protocol/web-common';
import { getPrivyProviderConfig } from 'client/modules/app/appData/getPrivyProviderConfig';
import { getWagmiConfigParams } from 'client/modules/app/appData/getWagmiConfigParams';
import { clientEnv } from 'common/environment/clientEnv';

const wagmiConfigParams = getWagmiConfigParams();

export function StackdPrivyProvider({ children }: WithChildren) {
  if (!clientEnv.integrations.isPrivyConfigured) {
    return children;
  }

  return (
    <PrivyProvider
      appId={clientEnv.integrations.privyAppId}
      config={getPrivyProviderConfig(wagmiConfigParams)}
    >
      {children}
    </PrivyProvider>
  );
}
